import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { toastFlashMessage } from "../utils";

const isDev = process.env.REACT_APP_ENV === "Staging"

const handleError = (error) => toastFlashMessage(getErrorMessage(error), "error");

const queryOptions = {
  logger: {
    error: () => {},
  },
  defaultOptions: {
    queries: {
      retry: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({ onError: handleError }),
  mutationCache: new MutationCache({ onError: handleError }),
};

export const queryClient = new QueryClient(queryOptions);

const QueryWrapper = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}

      {/* React query devtools config */}
      {isDev && (
        <ReactQueryDevtools
          position="bottom-right"
          toggleButtonProps={{ style: { width: "30px" } }}
          initialIsOpen={false}
          panelPosition="right"
        />
      )}
    </QueryClientProvider>
  );
};

export default QueryWrapper;

export const getErrorMessage = (error) =>
  error?.data?.message ||
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  "Unknown error";
